<div mat-dialog-content>
    <app-chart-view #chartView [fileId]="data.fileId" [chartType]="data.chartType" [filters]="data.filters" [viewState]="data.viewState">
    </app-chart-view>
</div>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'close' | translate }}</button>
</mat-dialog-actions>